<template>
    <div class="panel-container show">
        <div class="panel-content">
            <div class="d-flex flex-column align-items-center justify-content-center p-4">
                <h5 class="mb-0 fw-700 text-center mt-3" v-if="this.location.id > 0">
                    {{this.location.title}}
                </h5>

                <h5 class="mb-0 fw-700 text-center mt-3" v-else>
                    {{__t("NEW_REST")}}
                </h5>
            </div>
            <div>
                <div class="form-group mt-2">
                    <label class="form-label" for="advanced_name">
                        {{__t("REST_NAME")}}
                    </label>

                    <div class="input-group flex-nowrap">
                        <div class="input-group-prepend">
							<span class="input-group-text">
								<i class="fal  fa-typewriter fs-xl" ></i>
							</span>
                        </div>
                        <input id="advanced_name" type="text" class="form-control" v-model="location.title">
                    </div>
                </div>

                <template v-if="providerComponent">
                    <component :is="providerComponent" :location="location" />
                </template>

                <template v-else>
                    <slot :location="location" :name="location.provider + '_params'">
                        <div class="panel-tag mt-2">
                            {{__t("GLOVO_LOCATION_PARAMS")}}
                        </div>

                        <div class="form-group mt-2" v-for="general_field in general_fields" :key="general_field.key">
                            <label class="form-label">
                                {{ get_wolt_param_name(general_field.title) }}
                            </label>


                            <div class="input-group flex-nowrap" v-if="is_bool_field(general_field)">
                                <b-form-radio-group
                                    :id="'btn-radios-' + general_field.key"
                                    v-model="location.general_fields[general_field.key]"
                                    button-variant="outline-primary"
                                    :options="[
                                                  { text: 'YES', value: true },
                                                  { text: 'NO', value: false }
                                            ]"
                                    :name="'btn-radios-' + general_field.key"
                                    buttons
                                ></b-form-radio-group>

                            </div>



                            <div class="input-group flex-nowrap" v-if="!is_bool_field(general_field)">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">
                                        <i class="fal fa-typewriter fs-xl"></i>
                                    </span>
                                </div>
                                <input
                                    :id="general_field.key"
                                    type="text"
                                    class="form-control"
                                    v-model="location.general_fields[general_field.key]"
                                />
                            </div>



                        </div>
                    </slot>
                </template>

                <div class="panel-tag">
                    {{__t("BASE_PARAMS")}}
                </div>

                <div class="form-group mt-2">
                    <label class="form-label" for="linked_rest">
                        {{__t("LINKED_REST")}}
                    </label>

                    <div class="" v-if="restaurants.length > 0">
                        <v-select v-model="location.link_id"
                                  class="imc_reasons"
                                  id="linked_rest"
                                  label="title"
                                  :reduce="rest => rest.id"
                                  :filter="searchRest"
                                  :options="this.restaurants"
                        >
                            <template slot="no-options">
                                {{__t("CHOICE_REST")}}
                            </template>
                            <template slot="option" slot-scope="option">
                                <div class="d-center">
                                    <div>
                                        {{ option.title }}
                                    </div>
                                    <div>
                                        <small>
                                            {{option.uniq_id}} {{option.address}}
                                        </small>
                                    </div>
                                </div>
                            </template>
                        </v-select>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select';
import Fuse from 'fuse.js';

import wolt_drive_params from "../providers/wolt_drive_params.vue";
import yes_no from "../../../sys/radio/yes_no.vue";


export default {
    name: "delivery_general_tab",

    components : {
        vSelect,
        wolt_drive_params: wolt_drive_params,
        yes_no,
    },

    props : {
        location : {
            type : Object
        }
    },

    mounted() {
        this.load_restaurants();
    },

    data() {
        return {
            restaurants : [],
        }
    },

    methods : {
        is_bool_field(field) {
            return field && typeof field.value === 'boolean';
        },



        get_wolt_param_name(type)
        {
            return type;
        },

        async load_restaurants() {
            this.restaurants = [];
            await api.post('/internal/v1/catalog/restaurants',{
                "filter" : {
                    "organizations" : [this.location.parent_id]
                },
                "list" : {
                    "limit" : 100
                }
            }).then(({data}) => {
                if (data.status === "operation_success") {
                    this.restaurants = data.data;
                }
            }).catch(({response}) => {
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },

        searchRest(options, search) {
            const fuse = new Fuse(options, {
                keys: ['title', 'uniq_id', 'address'],
                shouldSort: true,
            })
            return search.length
                ? fuse.search(search).map(({ item }) => item)
                : fuse.list
        },
    },
    computed: {

        providerComponent() {
            const name = this.location.provider ? `${this.location.provider}_params` : null;
            if (name && this.$options.components[name]) {
                return name;
            }
            return null;
        },

        linked_restaurants() {
            if (this.location.hasOwnProperty("linked_childrens")) {
                return this.location.linked_childrens;
            }

            return [];
        },

        general_fields() {

            if(this.location.hasOwnProperty("general_fields")) {
                let res = [];
                for (const [key, value] of Object.entries(this.location.general_fields)) {
                    if(key != 'id') {
                        res.push({
                            key: key,
                            value: value,
                            title: this.__t(key.toUpperCase())
                        });
                    }
                }
                return res;
            }
            return [];
        },

    }
}
</script>

<style scoped>

</style>
